import { singletonQueryClient } from '$utils'
import dayjs from 'dayjs'
import { StockOnHandReport } from '@loadedhub/core-api-sdk'
import { coreApi, stockApi } from '$api'
import { StocktakeTemplate } from '@loadedhub/loaded-stock-api-sdk'

/**
 * Get stock on hand data
 * @param id the id of the template
 * @returns a stock on hand report
 */
export const getStockOnHand = async (
  templateId?: string,
  stockItemId?: string,
  reportDateTime?: dayjs.Dayjs
): Promise<StockOnHandReport> => {
  return singletonQueryClient.fetchQuery({
    queryKey: ['stock-on-hand', templateId, stockItemId, reportDateTime],
    queryFn: async () => {
      return await coreApi.getStockOnHand(
        templateId,
        stockItemId,
        reportDateTime
      )
    },
  })
}

/**
 * Get stock all stocktake templates
 * @returns a list of stocktake templates
 */
export const getAllStocktakeTemplates = async (
  includeDeleted: boolean
): Promise<StocktakeTemplate[]> => {
  return singletonQueryClient.fetchQuery({
    queryKey: ['stocktake-templates', includeDeleted],
    queryFn: async () => {
      const stocktakeTemplates = await stockApi.getAllStocktakeTemplates(
        includeDeleted
      )
      return stocktakeTemplates
    },
  })
}
